
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { toast } from 'sonner';
import { Shield, UserCheck } from 'lucide-react';

const Careers = () => {
  const navigate = useNavigate();
  const [isExistingUser, setIsExistingUser] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check if the user is already logged in
    const token = localStorage.getItem('authToken');
    const userType = localStorage.getItem('userType');
    
    // Set a timeout to prevent immediate redirects and show loading state
    const timeoutId = setTimeout(() => {
      if (token && userType === 'candidate') {
        setIsExistingUser(true);
        // Show a toast notification
        toast.info('You already have an account!', {
          description: 'Please sign in to access your account.',
          action: {
            label: 'Sign In',
            onClick: () => navigate('/login')
          },
        });
        setIsChecking(false);
      } else {
        // If not logged in, redirect to signup with security token
        const securityToken = Date.now().toString();
        sessionStorage.setItem('signupToken', securityToken);
        setIsChecking(false);
        navigate('/signup', { state: { securityToken } });
      }
    }, 1000);
    
    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-28 pb-16 flex items-center justify-center">
        <div className="text-center">
          {isChecking ? (
            <div>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 mb-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-apple-blue"></div>
              </div>
              <h1 className="text-2xl font-bold text-apple-text mb-4">
                Verifying your access
              </h1>
              <p className="text-apple-text-secondary mb-6">
                Please wait while we check your account status...
              </p>
            </div>
          ) : isExistingUser ? (
            <div>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 mb-4">
                <UserCheck className="h-8 w-8 text-apple-blue" />
              </div>
              <h1 className="text-2xl font-bold text-apple-text mb-4">
                You already have an account
              </h1>
              <p className="text-apple-text-secondary mb-6">
                Please sign in to access your account
              </p>
              <Link 
                to="/login" 
                className="px-6 py-2 bg-apple-blue text-white font-medium rounded-full hover:bg-opacity-90 transition-all"
              >
                Sign In Now
              </Link>
            </div>
          ) : (
            <div>
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 mb-4">
                <Shield className="h-8 w-8 text-apple-blue" />
              </div>
              <h1 className="text-2xl font-bold text-apple-text mb-4">
                Join True Talent Apply
              </h1>
              <p className="text-apple-text-secondary mb-6">
                Redirecting you to the signup page...
              </p>
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-apple-blue mx-auto"></div>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Careers;
